import React, { useState, useEffect, useRef } from 'react';
import { formatDate } from '../../utils/dateFormatting';
import styles from './FormattedDateInput.module.css';

const FormattedDateInput = ({ value, onChange, className, disabled, placeholder = 'MM/DD/YY', color }) => {
  const [internalValue, setInternalValue] = useState('');
  const [displayValue, setDisplayValue] = useState('');
  const inputRef = useRef(null);

  // Convert value to YYYY-MM-DD format for the date input and formatted display
  useEffect(() => {
    if (value) {
      const date = new Date(value);
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      setInternalValue(`${year}-${month}-${day}`);
      setDisplayValue(formatDate(value));
    } else {
      setInternalValue('');
      setDisplayValue('');
    }
  }, [value]);

  const handleChange = (e) => {
    const newValue = e.target.value;
    console.log('📅 [FormattedDateInput] Date selected:', newValue);
    setInternalValue(newValue);
    if (newValue) {
      setDisplayValue(formatDate(newValue));
    }
    onChange(newValue);
  };

  const handleWrapperClick = (e) => {
    e.stopPropagation();
    if (!disabled && inputRef.current) {
      // Temporarily enable pointer events to allow picker interaction
      inputRef.current.style.pointerEvents = 'auto';

      if (inputRef.current.showPicker) {
        try {
          inputRef.current.showPicker();
        } catch (err) {
          console.error('showPicker failed:', err);
        }
      }

      // Disable pointer events again after a short delay
      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.style.pointerEvents = 'none';
        }
      }, 100);
    }
  };

  return (
    <div
      className={styles.dateInputWrapper}
      style={color ? { color } : undefined}
      onClick={handleWrapperClick}
    >
      {/* Formatted date display overlay */}
      <div className={styles.formattedOverlay}>
        {displayValue || placeholder}
      </div>

      {/* Actual date input - hidden but functional */}
      <input
        ref={inputRef}
        type="date"
        value={internalValue}
        onChange={handleChange}
        disabled={disabled}
        onKeyDown={(e) => {
          // Prevent all keyboard input
          e.preventDefault();
          e.stopPropagation();
        }}
        onMouseDown={(e) => {
          // Prevent default text selection behavior
          e.preventDefault();
        }}
        tabIndex={-1}
        placeholder={placeholder}
        className={`${styles.dateInput} ${className || ''}`}
      />
    </div>
  );
};

export default FormattedDateInput;